
<ng-container *ngIf="role==='superadmin'">

<app-accordion-help [helps]="helps"></app-accordion-help>


<!--<div *ngFor="let account of accounts$ | async">-->
<!--  {{ account.name}}-->
<!--</div>-->
<!--fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="20px"-->
<div style="width: 300px;"
     ngClass.xs="page-margin-xs"
     ngClass.sm="page-margin-sm"
     ngClass="page-margin">

  <div >
    <mat-list>
      <mat-list-item>Agencys</mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
  </div>

<!--  <div>-->
<!--    <button mat-fab aria-label="Add Account" (click)="addAgency(false,null)" matTooltip="Add Account"-->
<!--            matTooltipPosition="right">-->
<!--      <mat-icon class="add-button">add</mat-icon>-->
<!--    </button>-->
<!--  </div>-->

  <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
    <mat-card class="mat-elevation-z24">
      <div class="mat-elevation-z24">
        <table mat-table [dataSource]="dataSource" matSort>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row"> {{row.name}} </td>
          </ng-container>


          <!-- View Column -->
          <ng-container matColumnDef="View">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button class="any-icon-light table-icon">
                <mat-icon style="cursor: pointer;" (click)="viewData(row)">visibility</mat-icon>
              </button>
            </td>
          </ng-container>


          <!-- Edit Column (click)="addAccount(true,row.Id)" -->
          <ng-container matColumnDef="Edit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button class="any-icon-light table-icon">
                <mat-icon style="cursor: pointer;" (click)="addAgency(true,row.Id)">edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Delete Column -->
          <ng-container matColumnDef="Delete">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Delete</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button class="warn-icon-light warn-icon">
                <mat-icon style="cursor: pointer;" (click)="deleteRow(row.Id)">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Star Column -->
          <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
            <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
              <mat-icon>more_vert</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
              (click)="getTableRecord(row)"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </mat-card>
  </div>

</div> <!--end flex container-->

</ng-container>
